import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SessionService } from '@core/services-v2/session/session.service';
import { ISession } from '@core/models-v2/auth/session.interface';
import { CustomerSaleService } from '@core/services-v2/customer-sale/customer-sale.service';
import { environment } from '@env/environment';
import { OmsService } from '@core/services-v2/oms.service';
import { TableLazyLoadEvent } from 'primeng/table';
import { FilterMetadata, MessageService } from 'primeng/api';

@Component({
  selector: 'app-page-orders-list',
  templateUrl: './page-orders-list.component.html',
  styleUrls: ['./page-orders-list.component.scss'],
  providers: [MessageService],
})
export class PageOrdersListComponent {
  usuario: ISession;
  loadingData = true;
  innerWidth: any;
  taxConfig = environment.tax;
  isB2b: boolean = false;
  isEnterprise: boolean = false;
  //Variables nueva tabla
  orders: any[] = [];
  totalRows: number = 0;
  rows: number = 10;
  first: number = 0;

  sortField: string | string[] = '';
  sortOrder: number = 1;
  loading: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private readonly sessionService: SessionService,
    private readonly customerSaleService: CustomerSaleService,
    private readonly omsService: OmsService,
    private readonly messageService: MessageService
  ) {
    this.usuario = this.sessionService.getSession();
    this.isB2b = this.sessionService.isB2B();
    this.isEnterprise = this.sessionService.isEnterprise();
    this.loadingData = false;
    this.innerWidth = isPlatformBrowser(this.platformId)
      ? window.innerWidth
      : 900;
  }

  /**
   * Obtener ordenes para la tabla.
   * @param event
   */

  fetchOrders(event: TableLazyLoadEvent) {
    this.first = event.first || 0;
    this.rows = event.rows || this.rows;
    this.sortField = event.sortField || '';
    this.sortOrder = event.sortOrder || 1;
    // const sort = event.sortField
    //   ? `${event.sortField}|${event.sortOrder}`
    //   : '';
    const sort = event.sortField
      ? `${event.sortField}|${event.sortOrder}`
      : 'timestamps|-1';
    const filters = [];
    for (let key in event.filters) {
      const item = event.filters[key] as FilterMetadata;
      if (item.value) {
        filters.push(`${key}|${item.value}`);
      }
    }
    this.loading = true;
    this.omsService
      .getOrdersAll({
        page: this.first / this.rows + 1,
        limit: this.rows,
        sort,
        search: filters.join(','),
        getOc: this.isEnterprise ? true : false,
      })
      .subscribe({
        next: (res: any) => {
          this.orders = res.data;
          this.orders.map((row: any) => {
            let invoice = null;
            row.documents.forEach((doc: any) => {
              if (doc.code === 'invoice') invoice = doc;
            });
            row.invoice = invoice;
            row.salesOrigin.name = this.changeOrigin(row.salesOrigin.name);
            row.status.statusName = this.changeStatus(row.status.statusName);
          });
          this.totalRows = res.total;
          this.loading = false;
        },
        error: (err) => {
          console.error(err);
          this.messageService.add({
            severity: 'error',
            summary: 'No se pueden obtener las ordenes',
            detail: 'Ha ocurrido un error al obtener las ordenes.',
          });
        },
      });
  }

  //funcion para cambiar el origin
  changeOrigin(name: string) {
    let origin = name;
    switch (name) {
      case 'VENTA B2C':
        origin = 'WEB';
        break;
      case 'VENTA B2B':
        origin = 'WEB';
        break;
      case 'VENTA CAJA':
        origin = 'CAJA';
        break;
      case 'VENTA TELEMARKETING':
        origin = 'TELEVENTA';
        break;
      default:
        origin = name;
    }
    return origin;
  }
  //funcion para cambiar el origin
  changeStatus(name: string) {
    let status = name;
    switch (name) {
      case 'Pedido Entregado':
        status = 'Entregado';
        break;
      default:
        status = name;
    }
    return status;
  }

  onResize(event: any) {
    this.innerWidth = event.target.innerWidth;
  }
}
